/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ValidateWeekendVisibilityChangeInput = {
    weekendDisplayPerUser?: boolean | null | undefined;
    weekendDisplayShowAlways?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type ValidateWeekendVisibilityChangeMutationVariables = {
    input: ValidateWeekendVisibilityChangeInput;
};
export type ValidateWeekendVisibilityChangeMutationResponse = {
    readonly validateWeekendVisibilityChange: {
        readonly isCompanyPrevented: boolean | null;
        readonly isActiveUserPrevented: boolean | null;
        readonly isInactiveUserPrevented: boolean | null;
    } | null;
};
export type ValidateWeekendVisibilityChangeMutation = {
    readonly response: ValidateWeekendVisibilityChangeMutationResponse;
    readonly variables: ValidateWeekendVisibilityChangeMutationVariables;
};



/*
mutation ValidateWeekendVisibilityChangeMutation(
  $input: ValidateWeekendVisibilityChangeInput!
) {
  validateWeekendVisibilityChange(input: $input) {
    isCompanyPrevented
    isActiveUserPrevented
    isInactiveUserPrevented
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ValidateWeekendVisibilityChangeInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateWeekendVisibilityChangePayload",
    "kind": "LinkedField",
    "name": "validateWeekendVisibilityChange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCompanyPrevented",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActiveUserPrevented",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isInactiveUserPrevented",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateWeekendVisibilityChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateWeekendVisibilityChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ValidateWeekendVisibilityChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateWeekendVisibilityChangeMutation(\n  $input: ValidateWeekendVisibilityChangeInput!\n) {\n  validateWeekendVisibilityChange(input: $input) {\n    isCompanyPrevented\n    isActiveUserPrevented\n    isInactiveUserPrevented\n  }\n}\n"
  }
};
})();
(node as any).hash = '2c9057dacf2b9b4dfe7a44060ac552c4';
export default node;
